import { configureStore } from '@reduxjs/toolkit'
import auth from '../services/auth'
import { setupListeners } from '@reduxjs/toolkit/query'
import authSlice from '../features/authSlice'
import replenishmentsystem from '../services/replenishmentSystem'
import home from '../services/home'
import consumer from '../services/consumer'
import orders from '../services/orders'
import product from '../services/product'
import reports from '../services/reports'
import ecom from '../services/ecom'
// import { PreloadedState } from '@reduxjs/toolkit'

export const store = configureStore({
  reducer: {
    authUser: authSlice,
    [auth.reducerPath]: auth.reducer,
    [home.reducerPath]: home.reducer,
    [consumer.reducerPath]: consumer.reducer,
    [replenishmentsystem.reducerPath]: replenishmentsystem.reducer,
    [orders.reducerPath]: orders.reducer,
    [product.reducerPath]: product.reducer,
    [reports.reducerPath]: reports.reducer,
    [ecom.reducerPath]: reports.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(auth.middleware, home.middleware, consumer.middleware, replenishmentsystem.middleware
      , orders.middleware, product.middleware, reports.middleware, ecom.middleware
    )
})
setupListeners(store.dispatch)